import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
  override serialize(tree: UrlTree): string {
    const url = super.serialize(tree);

    const [, path, rest] = url.match(/^([^?#]*)([?#].*)?$/) as RegExpMatchArray;

    if (path.length > 1 && !path.endsWith('/')) {
      return path + '/' + (rest ?? '');
    }

    return url;
  }
}
